// tr strings for messages/hub.ts. Same keys and {variables} as en there.
import type { Dict } from "../index";

const hub: Dict = {
  "hub.views.count": "10 milyar+",
  "hub.views.on": "izlenme",
  "hub.badge.covers": "10 milyon+ cover yapıldı",
  "hub.badge.quality": "Stüdyo kalitesinde sonuç",
  "hub.badge.youtube": "YouTube'da görüldüğü gibi",
  "hub.trending": "Trend",
  "hub.popular": "Şu an popüler sesler",
  "hub.browseAll": "Tümünü gör",
  "hub.byCategory": "Kategoriye göre sesleri keşfet",
  "hub.aiVoices": "Yapay zeka sesleri",
  "hub.howItWorks": "Nasıl çalışır?",
  "hub.faq": "Sıkça sorulan sorular",
  "hub.keepExploring": "Keşfetmeye devam et",
  "hub.moreWays": "Jammable ile üretmenin daha fazla yolu.",
  "hub.home": "Ana sayfa",

  "widget.title": "Başlamak için bir ses seç",
  "widget.search": "Ses ara",
  "widget.clear": "Aramayı temizle",
  "widget.matching": '"{q}" için bulunan sesler',
  "widget.popular": "Şu an popüler",
  "widget.noMatch": "Bu aramayla eşleşen ses yok.",
  "widget.searchAny": "Yukarıdan istediğin sesi ara.",
  "widget.coverWith": "Cover yap: {name}",
  "widget.start": "İstediğin bir sesle başla",
  "widget.rights":
    "Sonra sesini eklersin. Yalnızca kullanma hakkına sahip olduğun sesleri yükle.",

  "lang.viewThisPage": "Bu sayfayı Türkçe görüntüle",
  "lang.dismiss": "Kapat",
};

export default hub;
